'use strict'
import urls from './Urls'
import axios from 'axios'

export const CHILD_API_ENDPOINTS = {
  GET: 'get',
  SAVE: 'save',
  REMOVE: 'remove',
  SORT: 'sort',
  SPORT_REGION_ASSIGNMENTS: 'assignment/get',
  SPORT_REGION_ASSIGNMENTS_SAVE: 'assignment/save'
}

// Address Type End Points
function getAddressTypesEndPoint () {
  return urls.addressTypeApiController() + '/' + CHILD_API_ENDPOINTS.GET
}

function saveAddressTypeEndPoint () {
  return urls.addressTypeApiController() + '/' + CHILD_API_ENDPOINTS.SAVE
}

function removeAddressTypeEndPoint () {
  return urls.addressTypeApiController() + '/' + CHILD_API_ENDPOINTS.REMOVE
}

function loadAddressTypes () {
  return axios.get(this.getAddressTypesEndPoint())
}

// Owner End Points
function getOwnersEndPoint () {
  return urls.ownerApiController() + '/' + CHILD_API_ENDPOINTS.GET
}

function saveOwnerEndPoint () {
  return urls.ownerApiController() + '/' + CHILD_API_ENDPOINTS.SAVE
}

function removeOwnerEndPoint () {
  return urls.ownerApiController() + '/' + CHILD_API_ENDPOINTS.REMOVE
}

// Eligibility End Points
function getEligibilitiesEndPoint () {
  return urls.eligibilityApiController() + '/' + CHILD_API_ENDPOINTS.GET
}

function saveEligibilityEndPoint () {
  return urls.eligibilityApiController() + '/' + CHILD_API_ENDPOINTS.SAVE
}

function removeEligibilityEndPoint () {
  return urls.eligibilityApiController() + '/' + CHILD_API_ENDPOINTS.REMOVE
}

// Race End Points
function getRacesEndPoint () {
  return urls.raceApiController() + '/' + CHILD_API_ENDPOINTS.GET
}

function saveRaceEndPoint () {
  return urls.raceApiController() + '/' + CHILD_API_ENDPOINTS.SAVE
}

function removeRaceEndPoint () {
  return urls.raceApiController() + '/' + CHILD_API_ENDPOINTS.REMOVE
}

// Sport End Points
function getSportsEndPoint (academicYear, division) {
  let paramStr = '?academicYear=' + academicYear

  if (division) {
    paramStr += '&division=' + division
  }

  return urls.sportApiController() + '/getFiltered' + paramStr
}

function saveSportEndPoint () {
  return urls.sportApiController() + '/' + CHILD_API_ENDPOINTS.SAVE
}

function removeSportEndPoint () {
  return urls.sportApiController() + '/' + CHILD_API_ENDPOINTS.REMOVE
}

// Title End Points
function getTitlesEndPoint () {
  return urls.titleApiController() + '/' + CHILD_API_ENDPOINTS.GET
}

function saveTitleEndPoint () {
  return urls.titleApiController() + '/' + CHILD_API_ENDPOINTS.SAVE
}

function removeTitleEndPoint () {
  return urls.titleApiController() + '/' + CHILD_API_ENDPOINTS.REMOVE
}

// Member Type End Points
function getTypesEndPoint () {
  return urls.typeApiController() + '/' + CHILD_API_ENDPOINTS.GET
}

function saveTypeEndPoint () {
  return urls.typeApiController() + '/' + CHILD_API_ENDPOINTS.SAVE
}

function removeTypeEndPoint () {
  return urls.typeApiController() + '/' + CHILD_API_ENDPOINTS.REMOVE
}

// Citizenship End Points
function getCitizenshipsEndPoint () {
  return urls.citizenshipApiController() + '/' + CHILD_API_ENDPOINTS.GET
}

function saveCitizenshipEndPoint () {
  return urls.citizenshipApiController() + '/' + CHILD_API_ENDPOINTS.SAVE
}

function removeCitizenshipEndPoint () {
  return urls.citizenshipApiController() + '/' + CHILD_API_ENDPOINTS.REMOVE
}

// Current Year End Points
function getCurrentYearEndPoint () {
  return urls.currentYearApiController() + '/' + CHILD_API_ENDPOINTS.GET
}

function saveCurrentYearEndPoint () {
  return urls.currentYearApiController() + '/' + CHILD_API_ENDPOINTS.SAVE
}

// Division End Points
function getDivisionsEndPoint () {
  return urls.divisionApiController() + '/' + CHILD_API_ENDPOINTS.GET
}

function saveDivisionEndPoint () {
  return urls.divisionApiController() + '/' + CHILD_API_ENDPOINTS.SAVE
}

function removeDivisionEndPoint () {
  return urls.divisionApiController() + '/' + CHILD_API_ENDPOINTS.REMOVE
}

// Sport End Points
function getSportRegionsEndPoint (academicYear, division, sportCode) {
  let paramStr = '?academicYear=' + academicYear

  if (division) {
    paramStr += '&division=' + division
  }

  if (sportCode) {
    paramStr += '&sportCode=' + sportCode
  }

  return urls.sportRegionApiController() + '/getFiltered' + paramStr
}

function saveSportRegionEndPoint () {
  return urls.sportRegionApiController() + '/' + CHILD_API_ENDPOINTS.SAVE
}

function removeSportRegionEndPoint () {
  return urls.sportRegionApiController() + '/' + CHILD_API_ENDPOINTS.REMOVE
}

// Sport End Points
function getSportRegionAssignmentsEndPoint (/* academicYear, division, subdivision, sportCode */) {
  // let paramStr = '?academicYear=' + academicYear + '&division=' + division + '&sportCode=' + sportCode + '&subdivision=' + subdivision

  return urls.sportRegionApiController() + '/' + CHILD_API_ENDPOINTS.SPORT_REGION_ASSIGNMENTS //  + paramStr
}

function saveSportRegionAssignmentsEndPoint () {
  return urls.sportRegionApiController() + '/' + CHILD_API_ENDPOINTS.SPORT_REGION_ASSIGNMENTS_SAVE
}

// Discipline End Points
function getDisciplinesEndPoint () {
  return urls.disciplineApiController() + '/' + CHILD_API_ENDPOINTS.GET
}

function saveDisciplineEndPoint () {
  return urls.disciplineApiController() + '/' + CHILD_API_ENDPOINTS.SAVE
}

function removeDisciplineEndPoint () {
  return urls.disciplineApiController() + '/' + CHILD_API_ENDPOINTS.REMOVE
}

export default {
  // Address Type End Points
  getAddressTypesEndPoint: getAddressTypesEndPoint,
  saveAddressTypeEndPoint: saveAddressTypeEndPoint,
  removeAddressTypeEndPoint: removeAddressTypeEndPoint,
  loadAddressTypes: loadAddressTypes,
  // Owner End Points
  getOwnersEndPoint: getOwnersEndPoint,
  saveOwnerEndPoint: saveOwnerEndPoint,
  removeOwnerEndPoint: removeOwnerEndPoint,
  // Eligibility End Points
  getEligibilitiesEndPoint: getEligibilitiesEndPoint,
  saveEligibilityEndPoint: saveEligibilityEndPoint,
  removeEligibilityEndPoint: removeEligibilityEndPoint,
  // Race End Points
  getRacesEndPoint: getRacesEndPoint,
  saveRaceEndPoint: saveRaceEndPoint,
  removeRaceEndPoint: removeRaceEndPoint,
  // Sport End Points
  getSportsEndPoint: getSportsEndPoint,
  saveSportEndPoint: saveSportEndPoint,
  removeSportEndPoint: removeSportEndPoint,
  // Title End Points
  getTitlesEndPoint: getTitlesEndPoint,
  saveTitleEndPoint: saveTitleEndPoint,
  removeTitleEndPoint: removeTitleEndPoint,
  // Member Type End Points
  getTypesEndPoint: getTypesEndPoint,
  saveTypeEndPoint: saveTypeEndPoint,
  removeTypeEndPoint: removeTypeEndPoint,
  // Citizenship End Points
  getCitizenshipsEndPoint: getCitizenshipsEndPoint,
  saveCitizenshipEndPoint: saveCitizenshipEndPoint,
  removeCitizenshipEndPoint: removeCitizenshipEndPoint,
  // Current Year End Points
  getCurrentYearEndPoint: getCurrentYearEndPoint,
  saveCurrentYearEndPoint: saveCurrentYearEndPoint,
  // Division End Points
  getDivisionsEndPoint: getDivisionsEndPoint,
  saveDivisionEndPoint: saveDivisionEndPoint,
  removeDivisionEndPoint: removeDivisionEndPoint,
  // Sport Region End Points
  getSportRegionsEndPoint: getSportRegionsEndPoint,
  saveSportRegionEndPoint: saveSportRegionEndPoint,
  removeSportRegionEndPoint: removeSportRegionEndPoint,
  // Sport Region Assignment End Points
  getSportRegionAssignmentsEndPoint: getSportRegionAssignmentsEndPoint,
  saveSportRegionAssignmentsEndPoint: saveSportRegionAssignmentsEndPoint,
  // Discipline End Points
  getDisciplinesEndPoint: getDisciplinesEndPoint,
  saveDisciplineEndPoint: saveDisciplineEndPoint,
  removeDisciplineEndPoint: removeDisciplineEndPoint

}
